<template>
  <van-popup
    closeable
    close-icon-position="top-left"
    v-model="visible"
    position="right"
    :style="{ height: '100%', width: '90%' }"
  >
    <div class="pop-title">转账</div>
    <div class="custom-box">
      <div class="form-item">
        <label for="">类型</label>
        <van-radio-group
          direction="horizontal"
          class="form-item"
          name="radioGroup"
          v-model="transferMode"
          @change="changeTransferMode"
        >
          <van-radio name="2"> 跨订单转账 </van-radio>
          <van-radio name="1"> 订单内转账 </van-radio>
        </van-radio-group>
      </div>
      <div v-if="transferMode == 1" class="tip">
        *注：订单内转账只能转【消费项】且不能转【预订单】
      </div>
      <form-select
        label="筛选房号"
        v-model="roomInfoId"
        :columns="roomList"
        @change="handleChange"
        textKey="RoomNo"
        valueKey="RoomInfoId"
      ></form-select>

      <van-field
        label="转移订单"
        placeholder="请选择转移订单"
        @click="onSelectOrder"
        v-model="targetGuestName"
        right-icon="arrow"
        readonly
      />

      <van-field
        v-model="remark"
        rows="2"
        autosize
        label="备注"
        type="textarea"
        placeholder="请输入备注"
        :maxlength="70"
        show-word-limit
      />

      <div class="notice">
        <p slot="message">
          共选择<span style="color: #f00"> {{ selectData.length }} </span
          >条账项，其中付款项：<span style="color: #f00">￥{{ payAmount }}</span
          >； 消费项：<span style="color: #f00">￥{{ cosumeAmount }}</span>
        </p>
      </div>
      <van-checkbox-group v-model="selectData">
        <van-cell-group>
          <van-cell
            v-for="(item, index) in accountData"
            clickable
            :key="item.Id"
            @click="toggle(index)"
          >
            <div>
              <div>
                【{{ item.RoomNo || "" }}】 {{ item.AccountItemName }}
                <van-tag mark v-if="item.Type == 'C'" plain type="primary"
                  >付款项</van-tag
                ><van-tag mark v-else-if="item.Type == 'D'" type="warning" plain
                  >消费项</van-tag
                >
              </div>
              <div class="desc">
                账务日期: {{ moment(item.AccountDate).format("YYYY-MM-DD") }}
              </div>
              <div
                class="desc remark"
                v-if="item.TransferRemark"
                @click="viewTransferRecords(item.Id)"
              >
                转账备注: {{ item.TransferRemark }}
              </div>
            </div>
            <template #right-icon>
              <span class="price"> &yen;{{ item.TotalPrice }}</span>
              <van-checkbox :name="item" ref="checkboxes" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
    </div>
    <div class="footer-actions">
      <van-button @click="onCancel"> 取消</van-button>
      <van-button type="info" @click="onSubmit" :loading="confirmLoading">
        确定</van-button
      >
    </div>
    <TransferRecords ref="TransferRecords"></TransferRecords>
  </van-popup>
</template>

<script>
import calc from "@/utils/calc";
import selectRoomInfoModal from "../selectRoomInfo";
import moment from "moment";
import cloneDeep from "lodash/cloneDeep";
import TransferRecords from "./TransferRecords";
import formSelect from "@/components/form-select";
import orderApi from "@/api/order.js";
import { Notify } from "vant";
import {
  Checkbox,
  CheckboxGroup,
  NoticeBar,
  RadioGroup,
  Radio,
  Popup,
  Picker,
  Cell,
  CellGroup,
  Icon,
  Search,
  Button,
  Field,
  Tag,
} from "vant";
export default {
  components: {
    formSelect,
    [Tag.name]: Tag,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [NoticeBar.name]: NoticeBar,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [Search.name]: Search,
    [Button.name]: Button,
    [Field.name]: Field,
    TransferRecords,
  },
  props: {
    submit: {
      type: Function,
    },
    orderId: {
      type: [Number, String],
      default: "",
    },
    defaultItem: {
      type: Object,
      default: () => {},
    },
    currentRoom: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      moment,
      remark: "",
      activeKey: "",
      visible: true,
      confirmLoading: false,
      targetGuestId: "",
      targetGuestName: "",
      transferMode: "2",
      payAmount: 0,
      cosumeAmount: 0,
      accountData: [],
      selectData: [],

      roomInfoId: "",
      roomList: [],
      allAccounts: [],
    };
  },
  watch: {
    selectData(data) {
      let pay = 0,
        cosume = 0;
      if (data && data.length) {
        data.forEach(el => {
          if (el.Sign == "A" && el.ExtraSign != "O") {
            if (el.Type == "C" || el.isPreAuth) {
              pay = calc(el.TotalPrice)
                .add(pay)
                .number(2);
            } else if (el.Type == "D") {
              cosume = calc(el.TotalPrice)
                .add(cosume)
                .number(2);
            }
          }
        });
      }

      this.payAmount = pay;
      this.cosumeAmount = cosume;
    },
  },
  computed: {
    params() {
      let json = {};
      if (this.transferMode == 1) {
        json = {
          OrderStatusList: [1, 3],
          OrderId: this.orderId,
        };
        if (this.roomInfoId) {
          json = {
            OrderStatusList: [0, 1, 3],
            ExcludeRoomInfoId: this.roomInfoId,
            OrderId: this.orderId,
          };
        }
      } else {
        json = {
          ExcludeOrderId: this.orderId,
          OrderStatusList: [0, 1, 3],
        };
      }
      return json;
    },
  },
  created() {
    this.roomInfoId = (this.currentRoom || {}).RoomInfoId;
  },
  mounted() {
    this.visible = true;
    this.getAllAccounts();
  },
  methods: {
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    getAllAccounts() {
      orderApi.getOrderDetail({ Id: this.orderId }).then(res => {
        this.accountData = (res.Data.GuestAccounts || []).filter(
          el => el.Sign == "A" && el.ExtraSign != "O",
        );
        this.accountData.sort((a, b) => {
          return a.RoomNo - b.RoomNo;
        });
        this.allAccounts = cloneDeep(this.accountData);
        let list = [];
        (res.Data.Details || []).forEach(item => {
          if ([0, 1, 2, 3].includes(item.OrderStatus)) {
            list.push(item);
          }
        });
        this.roomList = list;
        // if (this.roomInfoId) {
        //   this.handleChange(this.roomInfoId);
        // }
      });
    },
    handleChange(val) {
      if (val) {
        const roomNo = val.RoomNo;
        const data = cloneDeep(this.allAccounts).filter(el => {
          if (
            (this.transferMode == 1 && el.Type == "D" && el.RoomNo == roomNo) ||
            (this.transferMode != 1 && el.RoomNo == roomNo)
          ) {
            return true;
          }
          return false;
        });
        this.accountData = data;
      } else {
        this.accountData = cloneDeep(this.allAccounts);
      }
      const ids = this.selectData.map(v => v.Id);
      const selects = [];
      this.accountData.forEach(el => {
        if (ids.includes(el.Id)) {
          selects.push(el);
        }
      });
      this.selectData = selects;
    },
    onSelectOrder() {
      selectRoomInfoModal({
        params: this.params,
        defaultItem: this.defaultItem,
        submit: data => {
          this.targetGuestId = data.Id;
          this.targetGuestName = `${data.OrderNo}/${data.RoomNo}/${
            data.GuestName
          }`;
          if (this.transferMode == 1) {
            const ids = this.selectData.map(v => v.Id);
            const selects = [];
            const list = cloneDeep(this.allAccounts).filter(el => {
              if (el.Type == "D" && el.RoomNo != data.RoomNo) {
                if (ids.includes(el.Id)) {
                  selects.push(el);
                }
                return true;
              }
              return false;
            });
            this.accountData = list;
            this.selectData = selects;
          }
        },
      });
    },
    onSelectCheckboxRows(record, selected, selectedRows) {
      this.selectData = selectedRows;
    },
    onSelectAllCheckbox(selected, selectedRows) {
      this.selectData = selectedRows;
    },
    changeTransferMode() {
      this.targetGuestId = "";
      this.targetGuestName = "";
      this.roomInfoId = "";
      const ids = this.selectData.map(v => v.Id);
      const selects = [];
      const data = cloneDeep(this.allAccounts).filter(el => {
        if (
          (this.transferMode == 1 && el.Type == "D") ||
          this.transferMode != 1
        ) {
          if (ids.includes(el.Id)) {
            selects.push(el);
          }
          return true;
        }
        return false;
      });
      this.accountData = data;
      this.selectData = selects;
    },
    onCancel() {
      this.visible = false;
    },
    async onSubmit() {
      try {
        let res = null;
        const { targetGuestId, selectData, remark } = this;
        if (!targetGuestId) {
          Notify("请选择转账的订单");
          return false;
        }
        if (!(selectData && selectData.length)) {
          Notify("请选择转账的账项");
          return false;
        }
        const data = {
          guestAccountIds: selectData.map(v => v.Id),
          targetRoomInfoId: targetGuestId,
          remark,
        };
        const that = this;
        that.confirmLoading = true;
        await orderApi.Transfer(data);
        Notify({ type: "success", message: "操作成功" });
        that.$emit("submit", res);
        that.visible = false;
        that.confirmLoading = false;
      } catch (error) {
        this.confirmLoading = false;
        console.warn(error);
      }
    },
    viewTransferRecords(id) {
      this.$refs.TransferRecords.onShow(id);
    },
  },
};
</script>
<style lang="less" scoped>
.custom-box {
  height: calc(100vh - 100px);
  overflow-y: auto;
  .van-checkbox-group {
    height: calc(100vh - 330px);
    overflow-y: auto;
    /deep/.van-cell {
      padding: 10px 5px;
      align-items: center;
    }
    .price {
      margin-right: 5px;
      color: #f00;
    }
    .desc {
      color: #666;
      font-size: 12px;
      padding-left: 5px;
    }
    .remark {
      line-height: 18px;
      color: #0185ff;
    }
  }
}
.form-item {
  display: flex;
  margin: 5px 0;
  font-size: 14px;
  align-items: center;
  label {
    width: 70px;
    font-size: 14px;
    padding-left: 15px;
    margin-right: 15px;
  }
  .van-radio {
    margin-right: 10px;
  }
}
/deep/.van-field__label {
  width: 70px;
}
.pop-title {
  height: 40px;
  background: #ececec;
  padding: 5px 10px;
  text-align: center;
  line-height: 32px;
}
/deep/.van-popup__close-icon {
  top: 12px;
}
.tip {
  color: #f00;
  font-size: 12px;
  padding-left: 85px;
}
.footer-actions {
  display: flex;
  button {
    flex: 1;
    margin: 0 5px;
  }
}
.notice {
  font-size: 12px;
  padding: 5px;
  background: #ffefd2;
}
</style>
